import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Boxes, CheckCircle2 } from "lucide-react";
import { api } from "../lib/api";
import { Loader, EmptyState } from "../components/Loader";
import { PageHeader } from "../components/PageHeader";

export default function Consolidate() {
  const [groups, setGroups] = useState(null);
  const [busy, setBusy] = useState(false);

  const load = async () => { try { setGroups(await api("/orders/consolidatable")); } catch { setGroups([]); } };
  useEffect(() => { load(); }, []);

  const merge = async (order_ids) => {
    if (!window.confirm("تجميع هذه الطلبات في شحنة واحدة؟")) return;
    setBusy(true);
    try { await api("/orders/consolidate", { method: "POST", body: JSON.stringify({ order_ids }) }); toast.success("تم تجميع الطلبات وتوفير رسوم التوصيل"); load(); }
    catch (e) { toast.error(e.message); } finally { setBusy(false); }
  };

  if (!groups) return <Loader />;

  return (
    <div className="animate-fade-in-up max-w-2xl mx-auto">
      <PageHeader title="تجميع الشحنات" />
      {groups.length === 0 ? <EmptyState icon={Boxes} title="لا توجد طلبات قابلة للتجميع حالياً" /> : (
        <div className="space-y-4">
          {groups.map((g, i) => (
            <div key={i} className="bg-white rounded-2xl border border-[#E8EAF2] p-4">
              <div className="flex items-center justify-between mb-2">
                <p className="font-black text-[#161629]">📍 {g.city}</p>
                <span className="text-xs font-black px-2 py-1 rounded-lg bg-[#D9F8E8] text-[#00D26A]">توفير {g.savings.toFixed(2)} د.ل</span>
              </div>
              {g.orders.map((o) => (
                <div key={o.order_id} className="flex justify-between text-sm py-1.5 border-b border-[#F0F2FA]">
                  <span className="text-[#161629]">{o.product_name}</span>
                  <span className="text-[#6B7280]">توصيل {Number(o.delivery_fee).toFixed(2)}</span>
                </div>
              ))}
              <div className="flex justify-between mt-3 text-sm">
                <span className="text-[#6B7280]">قبل: <s>{g.total_delivery_fee.toFixed(2)}</s> → بعد: <b className="text-[#00D26A]">{g.consolidated_delivery_fee.toFixed(2)} د.ل</b></span>
              </div>
              <button data-testid={`consolidate-${i}`} disabled={busy} onClick={() => merge(g.order_ids)} className="w-full flex items-center justify-center gap-2 h-11 rounded-xl bg-[#FF3D5A] text-white font-black mt-3"><CheckCircle2 size={18} /> تجميع في شحنة واحدة</button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
